import IRange from './interfaces/range.d';
import IImageCollectionSearchModel from '../image/interfaces/image-collection-search-model.d';

export default class Range implements IRange {
  public manufacturerName!: string;

  public manufacturerNameSlug!: string;

  public rangeId!: number;

  public rangeName: string = '';

  public rangeNameSlug!: string;

  public externalReferenceTypeId!: number;

  public externalReferenceTypeName!: string;

  public manufacturerId!: number;

  public manufacturerExternalReferenceId!: string;

  public rangeExternalReferenceId!: string;

  public active!: boolean;

  public fuelTypes!: string[];

  public bodystyles!: string[];

  public imageId!: number;

  public images!: IImageCollectionSearchModel;

  public imagePath!: string;
}
